import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider, ReactElement, ReactNode } from 'react';
import { axiosQueryFn } from 'app/agriculture/queries/axiosQueryFn';

export function ReactQueryContextProvider({
    children,
}: Readonly<{
    children: ReactNode;
}>): ReactElement<Provider<QueryClient>> {
    const queryClient = new QueryClient({
        defaultOptions: { queries: { staleTime: Infinity, queryFn: axiosQueryFn } },
    });
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
